// extracted by mini-css-extract-plugin
export var container = "SearchMenu-module--container--84725";
export var search = "SearchMenu-module--search--c0871";
export var searchBox = "SearchMenu-module--searchBox--ea8f2";